/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import { PostRequestAPI } from "../../Api/PostRequest";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import {
  ADD_COUPON_API_URL,
  PACKAGE_MANAGEMENT,
  UPDATE_COUPON_API_URL,
} from "../Shared/constant";
import {
  SelectPackagesTab,
} from "../../redux/actions/packageAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Scrollbars from "react-custom-scrollbars-2";
import { validateFormData } from "../Shared/utils";
import FormSelectCustome from "../CampaignManagement/Component/FormSelectCustome";
import Data from "../CampaignManagement/Component/Data";
import EmptySpaceFieldValid from "../Common/EmptySpaceFieldValid";
import FormInput from "../CampaignManagement/Component/FormInput";
import CommonLogout from "../Common/CommonLogout";
import { GetRequestCallAPI } from "../../Api/GetRequest";
import { CAMPAIGN_APPROVAL_LIST } from "../Shared/constant";
import {Spinner } from "react-bootstrap";


const AddCoupons = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();

  const { accessToken } = useSelector((state) => state.personalReducers);
  const { freeCouponList, CurrenUrlBaseForPackage } = useSelector(
    (state) => state.packageReducers
  );

  const Params_id = useParams();

  const matchData = freeCouponList?.data?.find((user) => user.id === Params_id?.coupon_id);
  const [loading, setLoading] = useState(false);
  const [campaignList, setCampaignList] = useState([]);

  const [formData, setFormData] = useState({campaign: "",coupon_code: "",quantity: "",coupon_type: "",amount: "", percentage: "",description: ""});
  const [error, setError] = useState({campaign: "",coupon_code: "",quantity: "",coupon_type: "",amount: "", percentage: "", description: ""});

  const CList = campaignList
    ?.filter?.((item) => item?.is_active && item?.status === "approved")
    ?.reverse()
    ?.map?.((item, index) => {
      const { id, title } = item;
      return {
        value: id,
        label: title,
      };
    });
  useEffect(() => {
    fetchData(1000, 1);
  }, []);

  useEffect(()=>{
    setFormData({
        campaign: matchData?.campaign?.id,
        coupon_code:matchData?.code ,
        quantity: matchData?.quantity,
        coupon_type:matchData?.code_details?.code_type,
        amount:matchData?.code_details?.amount,
        percentage:matchData?.code_details?.amount,
        description:matchData?.name,
      });
},[Params_id?.coupon_id])
  const fetchData = async (userLimit, currentPage) => {
    let url = `${CAMPAIGN_APPROVAL_LIST}/${userLimit}/${currentPage}?method=main`;
    url += `&sort_by=added_by`;

    const response = await GetRequestCallAPI(url, accessToken);
    if (response?.status === 200) {
      setCampaignList(response?.data?.data);
    } else if (response?.status === 403) {
      CommonLogout();
      setCampaignList([]);
    } else {
      setCampaignList([]);
    }
  };
  const onChange = (e) => {
    const values = {
      [e.target.name]: e.target.value,
    };
    if (e.target.name === "coupon_type") {
      values.amount = "";
    }
    setFormData((data) => ({
      ...data,
      ...values,
    }));
    setError((prev) => ({ ...prev, [e.target.name]: "" }));
  };
  const validationRules = useMemo(() => {
    const validate = {
      campaign: { required: true, title: "Please select" },
      coupon_code: { required: true, label: "Unique code" },
      quantity: { required: true, label: "Quantity", number: true },
      coupon_type: { required: true, title: "Please select coupon type" },
      amount: {
        required: formData?.coupon_type === "amount",
        label: "Amount",
        number: true,
      },
      percentage: {
        required: formData?.coupon_type === "flat",
        label: "Percentage",
        number: true,
      },
      // description: { required: true,label: "Description "},
    };
    if (formData?.coupon_type === "flat") {
      validate.percentage.maxDigit = 99;
    }
    return validate;
  }, [formData]);

  const AddCoupon = async () => {
    const validationErrors = validateFormData(formData, validationRules);
    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      const payload = {
        campaign_id: formData?.campaign,
        name: formData?.description,
        quantity: Number(formData?.quantity),
        code: formData?.coupon_code,
        code_details: {
          code_type: formData?.coupon_type,
          amount:
            formData?.coupon_type === "amount"
              ? Number(formData?.amount)
              : Number(formData?.percentage),
        },
      };
      const payload2 = {
        coupon_id: matchData?.id,
        name: formData?.description,
        quantity: Number(formData?.quantity),
        code_details: {
          code_type: formData?.coupon_type,
          amount:
            formData?.coupon_type === "amount"
              ? Number(formData?.amount)
              : Number(formData?.percentage),
        },
      };
      const response = await PostRequestAPI(
        matchData ? UPDATE_COUPON_API_URL : ADD_COUPON_API_URL,
        matchData ? payload2 : payload,
        accessToken,
        false
      );
      if (response?.status === 200) {
        toast.success(response?.data?.msg);
        setLoading(false);
        Navigate(PACKAGE_MANAGEMENT, { state: "free_coupon" });
      } else {
        toast.error(response?.data?.error);
        setLoading(false);
      }
    } else {
      setError(validationErrors);
    }
  };
  return (
    <>
      <ul className="tabcomnsection">
        {CurrenUrlBaseForPackage === "add-package" ? (
          <li
            className={
              CurrenUrlBaseForPackage === "add-package" ? "active" : ""
            }
            onClick={() => dispatch(SelectPackagesTab("add-package"))}
          >
            Add Free Coupon
          </li>
        ) : (
          <>
            <li
              className={
                CurrenUrlBaseForPackage === "edit-package" ? "active" : ""
              }
              onClick={() => dispatch(SelectPackagesTab("edit-package"))}
            >
              Edit Free Coupon
            </li>
          </>
        )}
        <div className="tabheadebuttns">
          {CurrenUrlBaseForPackage === "edit-package" && (
            <Button className="savchanges" onClick={() => AddCoupon()} disabled={loading}>
            {loading&&(<Spinner />)}  Save
            </Button>
          )}
          {CurrenUrlBaseForPackage === "add-package" && (
            <Button className="savchanges" onClick={() => AddCoupon()} disabled={loading}>
             {loading&&(<Spinner />)}  Add
            </Button>
          )}
          <Link
            className="btn savchanges linksmanage"
            to={PACKAGE_MANAGEMENT}
            state={"free_coupon"}
          >
            Back
          </Link>
        </div>
      </ul>
      <Scrollbars
        style={{ height: "calc(100vh - 162px)" }}
        className="ScrollbarsWrapper"
        renderView={(props) => <div {...props} className="view" />}
      >
        <section className="formsectionset px-3 d-flex flex-column">
          <div className="formloginset formeditset">
            <FormSelectCustome
              label="Campaign"
              name="campaign"
              value={formData.campaign}
              // options={Data?.optionCampaignType}
              options={CList}
              onChange={onChange}
              error={error?.campaign}
              required={true}
            />
            <FormInput
              label="Coupon Code"
              name="coupon_code"
              value={formData.coupon_code}
              onChange={onChange}
              onKeyDown={EmptySpaceFieldValid}
              placeholder="Enter coupon code"
              maxLength={100}
              error={error.coupon_code}
              labelClassName="col-md-4"
              divClassName="col-md-8"
              required={true}
            />
            <FormInput
              label="Quantity"
              name="quantity"
              value={formData.quantity}
              onChange={onChange}
              onKeyDown={EmptySpaceFieldValid}
              placeholder="Enter quantity"
              maxLength={100}
              error={error.quantity}
              labelClassName="col-md-4"
              divClassName="col-md-8"
              required={true}
              type="number"
            />
            <FormSelectCustome
              label="Coupon Type"
              name="coupon_type"
              value={formData.coupon_type}
              options={Data?.couponsType}
              onChange={onChange}
              error={error?.coupon_type}
              required={true}
            />
            {formData?.coupon_type === "amount" && (
              <FormInput
                label="Amount"
                name="amount"
                value={formData.amount}
                onChange={onChange}
                onKeyDown={EmptySpaceFieldValid}
                placeholder="Enter amount"
                maxLength={100}
                error={error.amount}
                labelClassName="col-md-4"
                divClassName="col-md-8"
                required={true}
                type="number"
              />
            )}
            {formData?.coupon_type === "flat" && (
              <FormInput
                label="Percentage"
                name="percentage"
                value={formData.percentage}
                onChange={onChange}
                onKeyDown={EmptySpaceFieldValid}
                placeholder="% percentage"
                maxLength={100}
                error={error.percentage}
                labelClassName="col-md-4"
                divClassName="col-md-8"
                required={true}
                type="number"
              />
            )}
            <FormInput
              label="Coupon Description"
              name="description"
              value={formData.description}
              onChange={onChange}
              onKeyDown={EmptySpaceFieldValid}
              placeholder="Enter description"
              maxLength={100}
              error={error.description}
              labelClassName="col-md-4"
              divClassName="col-md-8"
              required={false}
            />
          </div>
        </section>
      </Scrollbars>
    </>
  );
};
export default AddCoupons;
